import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage from "../_base/WPImage"

import * as twoColumnListSectionWithImageStyles from "../../styles/landing_pages/LandingTwoColumnListWithImageSection.module.css"

export default function LandingTwoColumnListWithImageSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `two-column-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const featuresList = ChildSelector.select(
    content,
    `two-column-list`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  return (
    <div
      className={`row ${props.className} ${twoColumnListSectionWithImageStyles.wrapper}`}
    >
      <div
        className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${twoColumnListSectionWithImageStyles.heading}`}
      >
        <h1
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <WPImage
          holder={content}
          selector={`img`}
          className={`${twoColumnListSectionWithImageStyles.image}`}
        />
      </div>
      <div
        className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${twoColumnListSectionWithImageStyles.content}`}
      >
        <ul className={`${twoColumnListSectionWithImageStyles.content}`}>
          {featuresList.childNodes.map((r, idx) => (
            <li
              key={idx}
              className={`${twoColumnListSectionWithImageStyles.contentItem}`}
              dangerouslySetInnerHTML={{ __html: r.innerHTML }}
            />
          ))}
        </ul>
      </div>
    </div>
  )
}
